module.exports = __webpack_public_path__ + "static/media/GCPMap.4ed4a74a.png";